export default __webpack_public_path__ + "static/media/heimdall-node-gold.9f6c118a.svg";